<template>
  <v-container class="margen_paginas pt-7" fluid>

    <TablaDatosAPI
      ref="tablaOperadores"
      :titulo="$t ('Operadores')"
      icono="mdi-account-key"
      tabla="ope"
      :campos="['id_ope-', 'corele+', 'nom+', 'id_rolope', 'fecalt-', 'id_empinq-', 'opesaginf-', '__ins_ope-', 'ultinises', 'blo-', 'gespasmulapa-']"
      :campos-filtrables="['id_rolope', 'id_empinq']"
      :parametros="parametros"
      busqueda-rapida
      :titulo-crud="$t ('operador')"
      permitir-anadir
      permitir-modificar
      permitir-eliminar
      :evento-antes-procesar-respuesta-servidor="eventoAntesProcesarRespuestaServidor">

      <template v-slot:debajo-titulo>
        <template v-if="$parametros_configuracion ['modempinq']">
          <v-tabs fixed-tabs background-color="#D7CCD7" v-model="tabSeleccionado" style="width: 100%" mobile-breakpoint="0" @change="actualizarTabla">
            <v-tab v-for="tab in arrayTabs" :key="tab.titulo"><v-icon class="mr-2">{{tab.icono}}</v-icon>{{ $t (tab.titulo) }}</v-tab>
          </v-tabs>
        </template>
      </template>

      <template v-slot:[`item.nom`]="{ item }">
          {{ item.nom }}
          <span v-if="item.blo != 0"><v-icon color="orange">mdi-lock</v-icon></span>
      </template>

    </TablaDatosAPI>

  </v-container>
</template>

<script>
import TablaDatosAPI from "@/components/TablaDatosAPI.vue";

export default {
  components: { TablaDatosAPI },
  data: () => ({
    arrayTabs: [
      { titulo: "Internos", icono: "mdi-home-account", parametro: "filtroInternos" },
      { titulo: "De empresas inquilinas", icono: "mdi-briefcase-account", parametro: "filtroDeEmpresasInquilinas" },
      { titulo: "Todos", icono: "mdi-account-multiple", parametro: "" },
    ],
    tabSeleccionado: 0
  }),
  computed: {
    parametros() {
      let aux = {};
      if (this.arrayTabs [this.tabSeleccionado].parametro)
        aux [this.arrayTabs [this.tabSeleccionado].parametro] = { valor: 1, descripcion: this.arrayTabs [this.tabSeleccionado].titulo };
      return aux;
    }
  },
  methods: {
    actualizarTabla(){
      this.$nextTick (() => {
        this.$refs.tablaOperadores.actualizarDatosPorCambiosEnBusqueda();
      });
    },
    eventoAntesProcesarRespuestaServidor (definicionCampos) {
      if (definicionCampos) {
        if (!this.$parametros_configuracion ['modempinq'])
          definicionCampos ['id_empinq'].visibilidad = "-";
      }
    }
  }
};
</script>

<style>
</style>